import React, { useEffect, useCallback, useState, ChangeEvent } from "react";
import { useDebounce } from "use-debounce";

import { Input, InputProps } from "../input";

export interface SearchInputProps extends InputProps {
  debounceMs: number;
}

export function SearchInput({
  value,
  onChange,
  debounceMs,
  ...props
}: SearchInputProps) {
  const [inputValue, setInputValue] = useState(value);
  const [debouncedValue] = useDebounce(inputValue, debounceMs);

  const handleSetInputValue = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => setInputValue(e.target.value),
    []
  );

  useEffect(() => {
    if (debouncedValue !== value) {
      const syntheticEvent = {
        target: { value: debouncedValue },
        currentTarget: { value: debouncedValue },
      } as React.ChangeEvent<HTMLInputElement>;

      onChange?.(syntheticEvent);
    }
  }, [debouncedValue, onChange, value]);

  return <Input {...props} value={inputValue} onChange={handleSetInputValue} />;
}
